var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24,3 0,24.600851 H 6.5454545 V 44.237215 H 21.818182 v -13.09091 h 4.363636 v 13.09091 H 41.454545 V 24.600851 H 48 Z m 0,5.8721564 13.090909,11.7826586 v 1.764218 17.454545 H 30.545455 V 26.782669 H 17.454545 V 39.873578 H 10.909091 V 20.654815 Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHome);
export default __webpack_public_path__ + "static/media/menu_home.f7dc0e48200aee8f100bb6a3264a3d9c.svg";
export { ForwardRef as ReactComponent };